"use client";

import { ThemeToggle } from "@components/header/theme-toggle";

export function AuthThemeToggle() {
  return (
    <div className="absolute right-4 top-4 z-20">
      <ThemeToggle />
    </div>
  );
}
